var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarQuestionmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 72,
    viewBox: "0 0 78 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875977 28.5696C0.875977 28.0592 1.28969 27.6455 1.80003 27.6455H66.4836C66.9939 27.6455 67.4076 28.0592 67.4076 28.5696V64.6075C67.4076 68.6903 64.0979 71.9999 60.0152 71.9999H8.26838C4.18566 71.9999 0.875977 68.6902 0.875977 64.6075V28.5696Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875977 18.0355C0.875977 13.9528 4.18567 10.6431 8.26838 10.6431H60.0152C64.0979 10.6431 67.4076 13.9528 67.4076 18.0355V20.8076C67.4076 21.318 66.9939 21.7317 66.4836 21.7317H1.80002C1.28968 21.7317 0.875977 21.318 0.875977 20.8076V18.0355Z",
    fill: "#D1D5DB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5015,
    y: 36.5164,
    width: 9.61013,
    height: 6.65316,
    rx: 1.8481,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 49.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 5,
    width: 10,
    height: 11,
    rx: 1.8481,
    fill: "#D1D5DB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.124,
    cy: 17,
    r: 17,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.124 4C57.5528 4 55.0394 4.76244 52.9016 6.19089C50.7638 7.61935 49.0975 9.64967 48.1136 12.0251C47.1297 14.4006 46.8722 17.0144 47.3738 19.5361C47.8754 22.0579 49.1136 24.3743 50.9316 26.1924C52.7497 28.0104 55.0661 29.2486 57.5879 29.7502C60.1096 30.2518 62.7235 29.9944 65.0989 29.0104C67.4743 28.0265 69.5047 26.3602 70.9331 24.2224C72.3616 22.0846 73.124 19.5712 73.124 17C73.1201 13.5534 71.7493 10.2491 69.3121 7.81191C66.875 5.37478 63.5706 4.00389 60.124 4ZM59.5588 24.913C59.3352 24.913 59.1167 24.8467 58.9308 24.7225C58.7449 24.5983 58.6 24.4217 58.5144 24.2152C58.4289 24.0086 58.4065 23.7814 58.4501 23.562C58.4937 23.3428 58.6014 23.1413 58.7595 22.9832C58.9176 22.8251 59.119 22.7175 59.3383 22.6739C59.5575 22.6302 59.7848 22.6526 59.9914 22.7382C60.198 22.8238 60.3745 22.9686 60.4987 23.1545C60.6229 23.3405 60.6892 23.559 60.6892 23.7826C60.6892 24.0824 60.5701 24.3699 60.3581 24.5819C60.1462 24.7939 59.8586 24.913 59.5588 24.913ZM64.5491 13.9478C64.4003 14.3653 64.1861 14.7564 63.9144 15.1065C63.3611 15.7425 62.7561 16.3315 62.1057 16.8677C61.5337 17.3119 61.0364 17.8446 60.6327 18.4458C60.3708 18.9648 60.2471 19.5426 60.2738 20.1234V20.4879H58.8472V19.8916C58.8207 19.1627 58.9558 18.437 59.2429 17.7664C59.6111 17.0851 60.1144 16.486 60.722 16.0058C61.4363 15.4574 62.0733 14.8149 62.6155 14.0959C62.8875 13.6274 63.0232 13.0921 63.0072 12.5506C63.0262 12.225 62.971 11.8993 62.8457 11.5981C62.7205 11.2969 62.5286 11.0281 62.2843 10.812C61.6856 10.3665 60.9477 10.1492 60.2031 10.1993C59.6302 10.1982 59.0593 10.2667 58.503 10.4034C57.8446 10.581 57.2079 10.8308 56.6044 11.1483L55.9533 9.6584C57.2952 8.94196 58.7928 8.56658 60.3139 8.56524C61.4977 8.49199 62.6662 8.8619 63.5922 9.60301C63.9903 9.97464 64.3016 10.4295 64.504 10.9352C64.7062 11.4408 64.7946 11.9849 64.7628 12.5286C64.772 13.0103 64.6998 13.4902 64.5491 13.9478Z",
    fill: "#DE6139"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarQuestionmark);
export default __webpack_public_path__ + "static/media/calendar-questionmark.e463da68.svg";
export { ForwardRef as ReactComponent };